import { render, staticRenderFns } from "./TheCharter.vue?vue&type=template&id=4cdbe48f&scoped=true&"
import script from "./TheCharter.vue?vue&type=script&lang=js&"
export * from "./TheCharter.vue?vue&type=script&lang=js&"
import style0 from "./TheCharter.vue?vue&type=style&index=0&id=4cdbe48f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdbe48f",
  null
  
)

export default component.exports